import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=026cdaa2&scoped=true&"
import script from "./NoticeList.vue?vue&type=script&lang=js&"
export * from "./NoticeList.vue?vue&type=script&lang=js&"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=026cdaa2&lang=scss&scoped=true&"
import style1 from "./NoticeList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026cdaa2",
  null
  
)

export default component.exports